import { Tooltip } from "antd";
import { hasHoverText } from "../../../utils/Constants/systemSetting";

export default function CustomTitleElement({
  heading = "",
  style = {},
  hoverText = "",
  element = <div></div>,
}) {
  return (
    <div style={{ width: "100%", display: "flex", ...style }}>
      {heading && hoverText ? (
        <Tooltip
          title={hoverText}
          overlayClassName="white-link"
          overlayInnerStyle={{ width: 500 }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h3 style={{ fontSize: 20, marginRight: 10, marginBottom: 0 }}>
              {hasHoverText(
                <span>
                  {heading.split(" ").map((head, index) => (
                    <span key={index}>{head}&nbsp;</span>
                  ))}
                </span>
              )}
            </h3>
          </div>
        </Tooltip>
      ) : heading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3 style={{ fontSize: 20, marginRight: 10, marginBottom: 0 }}>
            {heading.split(" ").map((head, index) => (
              <span key={index}>{head}&nbsp;</span>
            ))}
          </h3>
        </div>
      ) : (
        <div></div>
      )}
      <div>{element}</div>
    </div>
  );
}
